import IPasskey from '@/types/Settings/IPasskey';

const formatDate = (date: string): string =>
    new Date(date).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });

/**
 * "Added 3 Sep 2026 · Last used 20 Sep 2026" line for a passkey list row.
 */
export const describePasskey = (passkey: IPasskey): string =>
    [
        passkey.created_at ? `Added ${formatDate(passkey.created_at)}` : null,
        passkey.last_used_at
            ? `Last used ${formatDate(passkey.last_used_at)}`
            : 'Never used',
    ]
        .filter(Boolean)
        .join(' · ');
